<template>
  <div class="content-430">
    <PayListSearch @on-search="handleSearch"></PayListSearch>
    <div
      class="table-title-special-430"
      style="display: flex; justify-content: space-between; padding-top: 8px"
    >
      <h2>
        费用支出合计：<span class="color-red">{{ sumCount }}</span> 元
      </h2>
      <div>
        <Button
          v-if="portOrg != 2"
          type="primary"
          style="margin-right: 16px"
          @click="handleAdd"
        >新增费用支出</Button>
        <Button type="primary" @click="handleExport">下载</Button>
      </div>
    </div>
    <div class="table-wrap">
      <Table
        :columns="tableColumns"
        :data="tableList"
        :loading="loading"
        max-height="500"
        border
      >
        <template slot="outFeeType" slot-scope="{ row, index }">
          <span>{{ row.outFeeType == 3 ? '教师工资' : '其他支出' }}</span>
        </template>

        <template slot="amount" slot-scope="{ row, index }">
          <span>{{ abs(row.amount) }}</span>
        </template>
        <template slot="transSts" slot-scope="{ row, index }">
          <span>{{ getTransSts(row.transSts) }}</span>
        </template>

        <template slot="action" slot-scope="{ row, index }">
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleDetailed(row)"
          >查看详情</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :current="pageInfo.pageNum"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        @on-change="pageChange"
        @on-page-size-change="handleSizeChange"
      ></Page>
    </div>
    <PayListDetailed></PayListDetailed>
    <AddPay ref="addPayRef" @on-success="onAddPaySuccess"></AddPay>
    <PayListDetailed ref="payListDetailedRef"></PayListDetailed>
  </div>
</template>

<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';

import PayListSearch from './assets/components/PayListSearch.vue';
import PayListDetailed from './assets/components/PayListDetailed.vue';
import AddPay from './assets/components/AddPay.vue';
import financeCenterApi from '@/request/financeCenter/index.js';
import { abs, downloadReport } from '@/utils/utils.js';

export default {
  components: {
    PayListSearch,
    PayListDetailed,
    AddPay
  },
  data() {
    return {
      tableList: [],
      tableColumns: [
        key('转账流水号', 'recId', tableColumnsWidth.type4, {
          fixed: 'left'
        }),
        key('转账业务名称', 'busiName', tableColumnsWidth.type3, {
          fixed: 'left', tooltip: true
        }),
        slot('支出类型', 'outFeeType', 100, {
          fixed: 'left'
        }),
        key('学期', 'yearTerm', 190),
        key('转出方', 'outAcctName', tableColumnsWidth.type6),
        key('转出方账号', 'schoolAcctNo', 170),
        key('转入方', 'inAcctName', tableColumnsWidth.type6),
        key('转入方账号', 'inAcctNo', 170),
        slot('金额（元）', 'amount', 130),
        key('备注', 'remark', tableColumnsWidth.type5, {
          tooltip: true
        }),
        key('发起时间', 'createTime', tableColumnsWidth.type4),
        key('完成时间', 'transStsTime', tableColumnsWidth.type4),
        key('操作人', 'creatorName', tableColumnsWidth.type3),
        slot('状态', 'transSts', 120),
        slot('操作', 'action', tableColumnsWidth.type3, {
          fixed: 'right'
        })
      ],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },

      pageSizeOpts: [10, 20, 50, 100],
      loading: false,
      searchConds: {},
      sumCount: 0,
      portOrg: localStorage.getItem('portOrg')
    };
  },
  methods: {

    handleSearch(searchConds) {
      this.searchConds = searchConds;
      this.getSumAmount();
      this.getPageByCondition();
    },
    handleExport() {
      this.expenseTransExportApi();
    },
    handleAdd() {
      this.$refs.addPayRef.handleShow();
    },
    handleDetailed(row) {
      this.$refs.payListDetailedRef.handleShow(row.recId);
    },
    abs(num) {
      return abs(num);
    },
    onAddPaySuccess() {
      this.pageInfo.pageNum = 1;
      this.getPageByCondition();
      this.getSumAmount();
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getPageByCondition();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getPageByCondition();
    },
    // 金额合计
    async getSumAmount() {
      const parameter = {
        ...this.searchConds
      };
      const res = await financeCenterApi.getSumAmountApi(parameter);
      if (res.status == 200) {
        this.sumCount = abs(res.message);
      }
    },
    getTransSts(sts) {
      const map = {
        1: '交易成功',
        2: '交易失败',
        3: '交易处理中'
      };
      return map[sts] ? map[sts] : '';
    },
    // 导出
    async expenseTransExportApi() {
      const params = Object.assign({}, this.searchConds);
      for (const k in params) {
        if (params[k] === '') {
          delete params[k];
        }
      }
      let url;
      if (this.portOrg == 0) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/admin/schExpenseTransRecs/expenseTransExport`;
      } else if (this.portOrg == 2) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/school/schExpenseTransRecs/expenseTransExport`;
      }
      console.log(url, params);
      downloadReport(url, params, this);
    },
    async getPageByCondition() {
      const parameter = {
        ...this.searchConds,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize

      };
      this.loading = true;
      const res = await financeCenterApi.getPageByConditionApi(parameter);
      this.loading = false;
      if (res.status == 200) {
        this.tableList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    }
  }
};
</script>

<style>
</style>
